<template>
  <div class="preview__page">
    <v-card color="#F7F8FC" class="pa-9" flat rounded="3">
      <router-link to="/forum">
        <v-icon>mdi-chevron-left</v-icon>
        <span class="black--text">Back</span></router-link
      >
      <v-row class="mt-9">
        <v-col cols="12" md="2">
          <v-card flat color="transparent">
            
            <img
              style="height: 110px; width: 120px; object-fit:object-position: center; background-color: white;"
              :src="
                image(GetPreviewData.SubmittedByProfileImage) ||
                  'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
              "
              @error="setDefaultImage"
            />
          </v-card>
        </v-col>
        <v-col cols="12" md="10">
          <v-card color="white" outlined>
            <v-row>
              <v-col cols="12" md="12" class="pa-11">
                <div>
                  <div class="d-flex justify-space-between">
                    <div>
                      <span class="span_1"
                        >Posted by {{ GetPreviewData.SubmittedByName }}</span
                      >
                    </div>
                    <div>
                      <span class="index_h4">{{
                        GetPreviewData.CreatedDate.split("T")[0]
                      }}</span>
                    </div>
                  </div>
                  <div class="my-4">
                    <span class="heading-4">{{ GetPreviewData.Title }}</span>
                  </div>
                  <div class="mb-5" v-html="GetPreviewData.Description"></div>
                </div>
                <v-img
                  v-if="
                    GetPreviewData.ImgVid &&
                    imgExtenstion.includes(
                      GetPreviewData.ImgVid.split('.')
                        .slice(-1)
                        .join()
                        .toLowerCase()
                    )
                  "
                  class="image mt-5"
                  :src="imgVidFile(GetPreviewData.ImgVid)"
                  alt="img"
                />
                <video v-else width="196" height="115" controls>
                  <source
                    :src="imgVidFile(GetPreviewData.ImgVid)"
                    type="video/mp4"
                  />
                </video>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-card>

    <!-- <v-row v-for="(item, index) in LatestForumPostsData" :key="index">
      <v-col cols="12" md="2">
        <v-card flat color="transparent">
          <v-img
            max-height="110"
            :src="GetPreview.SubmittedByProfileImage"
          ></v-img>
        </v-card>
      </v-col>
      <v-col cols="12" md="10">
        <v-card color="white" outlined class="px-7 pb-4">
          <v-row>
            <v-col
              cols="12"
              md="12"
              style="align-content: space-between; display: grid"
            >
              <div>
                <div class="d-flex">
                  (icon)

                  <div class="mx-4">
                    <span class="span_1"
                      >Posted by {{ GetPreview.SubmittedByName }}</span
                    >
                  </div>
                  <div>
                    <span class="index_h4">{{
                      GetPreview.CreatedDate != null
                        ? GetPreview.CreatedDate.split("T")[0]
                        : ""
                    }}</span>
                  </div>
                </div>
                <div class="my-4">
                  <span class="heading-4">{{ GetPreview.Title }}</span>
                </div>
              </div>
              <iframe
                :src="GetPreview.ImgVid"
                style="width: 100%"
                class="mt-4"
              ></iframe>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "PreviewForumComponent",
  components: {},

  data() {
    return {
      imgExtenstion: ["jpg", "png", "gif", "svg", "jpeg", "jfif", "webp"],
      GetPreviewData: {},
    };
  },
  computed: {
    ...mapGetters(["GetPreview"]),
  },

  methods: {
    setDefaultImage(event) {
      event.target.src = 'https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png'
    },
    imgVidFile(file) {
      // return file ? process.env.VUE_APP_IMG_URL + file : "";
      return file ? file : "";
    },
    image(imageUrl) {
      return imageUrl
        // ? process.env.VUE_APP_IMG_URL + imageUrl
        ? imageUrl
        : "https://www.freeiconspng.com/thumbs/profile-icon-png/profile-icon-1.png";
    },
  },
  mounted() {
    this.GetPreviewData = this.GetPreview;
    const dataToStore = JSON.stringify(this.GetPreview);
    if (this.GetPreview) {
      localStorage.setItem("GetPreviewData", dataToStore);
    }
    const storedData = localStorage.getItem("GetPreviewData");
    if (!this.GetPreview) {
      this.GetPreviewData = JSON.parse(storedData);
    }
  },
};
</script>

<style scoped>
.preview__page >>> img {
  max-width: 100%;
}
.preview__page >>> .ql-video,
video,
.image {
  width: 100%;
  max-width: 400px;
  height: 220px;
}
</style>
